import { createAction, props } from "@ngrx/store";
import {
  AppNotification,
  AppTriggeredNotification,
} from "src/app/models/notifications/notification";

export const notify = createAction(
  "[Notification] notify",
  props<{
    notification: AppNotification;
  }>(),
);

export const notificationTriggered = createAction(
  "[Notification] notification triggered",
  props<{
    triggeredNotification: AppTriggeredNotification;
  }>(),
);

export const clearNotification = createAction(
  "[Notification] clear",
  props<{ notification: AppTriggeredNotification }>(),
);
